import clsx from "clsx";
import { FC } from "react";

import { EvalError } from "@tsmono/inspect-common/types";
import { RenderedContent } from "@tsmono/inspect-components/content";
import {
  ANSIDisplay,
  Card,
  CardBody,
  CardHeader,
  ExpandablePanel,
} from "@tsmono/react/components";

import styles from "./TaskErrorPanel.module.css";

interface TaskErrorProps {
  error: EvalError;
}

export const TaskErrorCard: FC<TaskErrorProps> = ({ error }) => {
  return (
    <Card>
      <CardHeader icon="error" label={`Task Failed`}></CardHeader>
      <CardBody>
        <ExpandablePanel
          id="task-error-collapse"
          collapse={true}
          className={clsx("text-size-smaller", styles.message)}
        >
          <RenderedContent
            id="task-error-message"
            entry={{ name: "error", value: error.message }}
          />
        </ExpandablePanel>
        <ANSIDisplay
          output={error.traceback_ansi}
          className={styles["task-error-display"]}
        />
      </CardBody>
    </Card>
  );
};
